import script from "./SixPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SixPage.vue?vue&type=script&setup=true&lang=js"

import "./SixPage.vue?vue&type=style&index=0&id=70df6c08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70df6c08"]])

export default __exports__